import React from 'react'
import { useSelector } from 'react-redux'
import { AppState } from 'web-common'
import { PuzzlesListingCards } from '../../../user-registration/breach/components/PuzzlesBreach/PuzzlesListingCards'
import {
    PuzzleListingBanner,
    PuzzleListingContainer,
    PuzzleListingDescription,
} from './PuzzleListing.styled'

const leftBgImage = require<string>('./assets/banner-left-asset.png')
const rightBgImage = require<string>('./assets/banner-right-asset.png')
const leftBgImageMobile = require<string>('./assets/mob-left.png')
const rightBgImageMobile = require<string>('./assets/mob-right.png')

export function PuzzleListing() {
    const appState = useSelector((state: AppState) => state)
    const renditionType = appState.render.renditionType

    return (
        <div>
            {renditionType !== 'app' && (
                <PuzzleListingDescription>
                    Stay sharp and challenge yourself with daily puzzles from
                    The West.
                </PuzzleListingDescription>
            )}
            <PuzzleBanner renditionType={renditionType} />
            <PuzzleListingContainer>
                <PuzzlesListingCards disabled={false} />
            </PuzzleListingContainer>
        </div>
    )
}

export function PuzzleBanner(props: { renditionType?: string }) {
    return (
        <PuzzleListingBanner
            leftImage={{ mobile: leftBgImageMobile, desktop: leftBgImage }}
            rightImage={{
                mobile: rightBgImageMobile,
                desktop: rightBgImage,
            }}
            isApp={props.renditionType === 'app'}
        >
            <p>
                New puzzles <span>every day.</span>
            </p>
        </PuzzleListingBanner>
    )
}
